import { useRef, useState } from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";
import BaseControl from "./BaseControl";
import Label from "./Label";
import { Overlay, Stack, Tooltip } from "react-bootstrap";

const ColorPickerControl = ({
    id="id",
    text="Text",
    edit=true,
    value="#aabbcc", 
    onChanged=(id:string,val:string)=>{}}) => {
    const newValue = value.length > 7 ? "#" + value.substring(value.length - 6) : value
    const [color, setColor] = useState(newValue);
    const [visible, setVisible] = useState(false);
    const target = useRef(null)
    
    const _onChanged = (newColor:string) => {
        newColor = newColor.length > 7 ? "#" + newColor.substring(newColor.length - 6) : newColor
        setColor(newColor)
        //console.log("#ff" + newColor.substring(1))
        onChanged(id, "#ff" + newColor.substring(1))
    }
    if (!edit && visible) setVisible(false)

    const onToggleVisible = () => {
        if (!edit) return
        setVisible(!visible)
    }
    return (
        <>
        <BaseControl text={text}>
            <button className="btn-picker" ref={target} onClick={onToggleVisible}>
                <Stack direction="horizontal" gap={2}>
                    <div style={{width: 15, height: 15, backgroundColor:color}}/>
                    <Label padding="0" fontWeight="400">{"#ff"+color.substring(color.length-6)}</Label>
                </Stack>
            </button>
        </BaseControl>
        <Overlay target={target.current} show={visible} placement="top">
            {(props) => (
                <Tooltip {...props} className="colorpicker">
                    <Stack gap={2}> 
                        <HexColorPicker style={{width:"150px",height:"150"}} color={color} onChange={_onChanged} />
                        <HexColorInput style={{width:"150px",height:"150"}} prefixed alpha color={"#ff"+color.substring(1)} onChange={_onChanged} />
                    </Stack>
                </Tooltip>
            )}
        </Overlay>
        </>
    );
}

export default ColorPickerControl;